<div *ngIf="score; then thenBlock else elseBlock"></div>
<ng-template #thenBlock><report-value>{{ score | number:'1.2-2' }}</report-value></ng-template>
<ng-template #elseBlock><report-value>- -</report-value></ng-template>